import { colors } from '@atlaskit/theme';

import { onDesktop, onMobile } from '../mobile/responsive';

export const DESKTOP_CARD_SIZE = 144;
export const MOBILE_CARD_SIZE = 88;

export const cardContainerStyle = `
  cursor: pointer;
  display: block;
  color: ${colors.N400};
  text-align: center;

  &:focus {
    outline: none;
  }

  &:hover {
    color: ${colors.B300};
    text-decoration: none;
  }

  // Bigger card size for desktop
  ${onDesktop(`
    width: ${DESKTOP_CARD_SIZE}px;
  `)}

  // Smaller card size for mobile
  ${onMobile(`
    width: ${MOBILE_CARD_SIZE}px;
  `)};
`;

export const iconContainerStyle = `
  box-sizing: border-box;
  margin: 0 auto 16px auto;
  padding: 24px;

  // Bigger icon for desktop
  ${onDesktop(`
    height: 96px;
    width: 96px;
    border-radius: 16px;
  `)}

  // Smaller icon for mobile
  ${onMobile(`
    height: 40px;
    width: 40px;
    padding: 8px;
    border-radius: 8px;

    span {
      width: 24px;
      height: 24px;
    }
  `)}
`;
